export enum ServiceTicketValidationAction {
    Store,
    Update,
}
